import { styled } from "@mui/system";
import Colors from "src/general/constants/colors";
import BreakPoints from "src/general/constants/breakPoints";

export const ListNavigation = styled("ul")(({ theme }) => ({
	display: "flex",
	flex: 1,
	margin: 34, //30
	gap: "78px", // 32
	[`@media (min-width: ${BreakPoints.LARGE_1439}px) and (max-width: ${BreakPoints.FHD_1919}px)`]:
		{
			gap: "54px",
		},
	[`@media (max-width: ${BreakPoints.LARGE_1439}px)`]: {
		gap: "10px",
	},
	[`@media (max-width: ${BreakPoints.TABLET_1023}px)`]: {
		display: "none",
	},
	">li:first-child>a": {
		width: "min-content",
	},
}));

export const ItemNavigation = styled("li")({
	display: "flex",
	position: "relative",
	width: "100%",
	height: "auto",
});

export const Link = styled("a")({
	display: "flex",
	justifyContent: "center",
	alignItems: "center",
	textAlign: "center",
	cursor: "pointer",
	position: "relative",
	width: "100%",
	"&:after": {
		content: '""',
		position: "absolute",
		height: "2px",
		background: Colors.PEOPLE_2,
		bottom: "-2px",
		left: "50%",
		transform: "translate(-50%, 0px)",
		transition: "0.3s",
	},
	"&:hover:after": {
		width: "100%",
	},
	"&:hover": {
		"& svg": {
			transform: "rotate(180deg)",
			transition: "all 0.1s linear",
		},
	},
});

export const LogoWrapper = styled("div")(({ theme }) => ({
	display: "flex",
	justifyContent: "center",
	alignItems: "center",
	gap: "8px",
}));

interface HoverProp {
	isHovered: boolean;
}

export const ArrowWrapper = styled("span")<HoverProp>((isHovered) => ({
	display: "flex",
	alignItems: "center",
	justifyContent: "center",
	"& svg": {
		marginLeft: "5px",
		marginTop: "3px",
		transition: "all 0.1s linear",
		[`@media (max-width: ${BreakPoints.FHD_1920}px)`]: {
			height: "7px",
		},
	},
	"&:hover": {
		"& svg": {
			transform: "rotate(180deg)",
		},
	},
}));
